import { Test } from './healthcheck.model';

export interface SavelabTestPackage {
  applicationId: number;
  labTests: LabTestPackage[];
}

export class LabTestPackage {
  id?: number;
  profileId?: number;
  test?: Test;
  price = 0;
  discountedPrice = 0;
  packageName = '';
  statusName = '';
  isActive = false;

}

export interface SaveLabTestPackageResponse {
  isSuccess: boolean;
  errorMessage: string;
  ids: number[];
}
